import { useContext } from "react";
import { translate } from "../../../../utils/Common";
import AuthContext from "../../../../contexts/auth/index";
import TablePaginationPlatforms from "../../../../components/TablePaginationPlatforms";

// estatus de las plataformas
const StatusPlatforms = ({ statusPlatforms }) => {
  const UserContext = useContext(AuthContext);
  // The table styles the cells; the caller only names the columns. Numeric ones
  // are right-aligned so their digits line up with the values underneath.
  const headerRow = (
    <tr>
      <th>{translate("dashboard.home.status_platforms.platform")}</th>
      <th>{translate("dashboard.home.status_platforms.status")}</th>
      {UserContext.user?.IsAdmin && (
        <th>{translate("dashboard.home.status_platforms.last_connection")}</th>
      )}
      <th className="text-right">{translate("dashboard.home.packages_platforms.title")}</th>
      <th className="text-right">{translate("dashboard.awaitingDelivery.title")}</th>
      <th className="text-right">{translate("global.packages_toCollect.title")}</th>
      <th className="text-right">{translate("global.packages_expired.title")}</th>
    </tr>
  );

  return ( <TablePaginationPlatforms data={statusPlatforms} headerRow={headerRow} title={translate("global.summaryPlatforms")} filterStatus notFound={translate("dashboard.home.status_platforms.asign")}/> );
};

export default StatusPlatforms;
